module.exports = __webpack_public_path__ + "static/img/gasa.cb0e60d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gasa.jpg
// module id = JhVm
// module chunks = 1